import { FormFieldBlueprint } from '@backstage/plugin-scaffolder-react/alpha';
import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';

export const liveValidatePlatformNameWithRegexFormFieldExtension: ExtensionDefinition =
  FormFieldBlueprint.make({
    name: 'live-validate-platform-name-with-regex-form-field-extension',
    params: {
      field: () =>
        import('./live-validate-platform-name-regex').then(
          m => m.LiveValidatePlatformNameWithRegexFormField,
        ),
    },
  });
